export const DAY_BEGIN = { hour: 0, minute: 0, second: 0, millisecond: 0 };

export const MS_FORMAT = 'x';
export const FULL_DATE_CHART_FORMAT = 'ddd, MMM DD YYYY HH:mm';
export const DATE_CHART_FORMAT = 'ddd, MMM DD YYYY';
export const DATE_CHART_FORMAT_FULL = 'dddd, MMM DD YYYY';
export const DATE_MONTHLY_FORMAT = 'MMMM YYYY';
export const DATE_DAILY_FORMAT = 'DD MMMM YYYY';
export const DATE_DAILY_SHORT_FORMAT = 'YYYY-MM-DD';
export const CSV_FULL_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const FULL_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
